// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__u_ZVT","boxTitle":"Qualiphy_boxTitle__1lOTv","box":"Qualiphy_box__30fK2","toggleWrap":"Qualiphy_toggleWrap__7XcW0"};